import { ApplicationFormStatusResponseDTO } from '@/api/application/DTOs';
import { ApplicationStatus } from '@/typings';

export const adaptApplicationFormStatusResponseToApplicationStatus = (
  applicationFormStatus: ApplicationFormStatusResponseDTO,
): ApplicationStatus => {
  switch (applicationFormStatus) {
    case ApplicationFormStatusResponseDTO.NotStarted:
      return ApplicationStatus.NotStarted;
    case ApplicationFormStatusResponseDTO.InProgress:
      return ApplicationStatus.InProgress;
    case ApplicationFormStatusResponseDTO.ProviderReviewed:
      return ApplicationStatus.ProviderReviewed;
    case ApplicationFormStatusResponseDTO.SubmittedToGemini:
      return ApplicationStatus.SubmittedToGemini;
    case ApplicationFormStatusResponseDTO.InValidation:
      return ApplicationStatus.InValidation;
    case ApplicationFormStatusResponseDTO.Verified:
      return ApplicationStatus.Verified;
  }
};
